module.exports = __webpack_public_path__ + "img/nozzle-logo.2245579.svg";